"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StandardIconWrapper = _interopRequireDefault(require("./StandardIconWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var HealthIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(HealthIcon, _React$PureComponent);

  function HealthIcon() {
    _classCallCheck(this, HealthIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(HealthIcon).apply(this, arguments));
  }

  _createClass(HealthIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["color", "className"]);
      /* eslint-disable max-len */


      return _react.default.createElement(_StandardIconWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'health-icon')
      }, props), _react.default.createElement("g", null, _react.default.createElement("path", {
        fill: color,
        d: "M3.8867,6.001 L4.7777,4.301 C4.8597,4.145 5.0177,4.043 5.1937,4.033 C5.3617,4.022 5.5367,4.107 5.6357,4.253 L7.1597,6.516 L7.8067,5.243 C7.8917,5.075 8.0637,4.97 8.2517,4.97 L8.2547,4.97 L11.9297,4.994 C11.9527,4.845 11.9787,4.695 11.9907,4.543 C12.1217,2.715 10.9547,1.062 9.1527,0.735 C7.9167,0.513 6.7767,0.941 6.0027,1.731 C5.2297,0.941 4.0887,0.513 2.8537,0.735 C1.0497,1.062 -0.1163,2.715 0.0157,4.543 C0.0527,5.051 0.1707,5.535 0.3397,6 L3.8867,6.001 Z"
      }), _react.default.createElement("path", {
        fill: color,
        d: "M8.5576,5.9717 L7.6656,7.7267 C7.5856,7.8837 7.4286,7.9887 7.2506,7.9987 C7.2416,7.9987 7.2306,7.9997 7.2206,7.9997 C7.0546,7.9997 6.8996,7.9177 6.8056,7.7797 L5.2746,5.5067 L4.6326,6.7337 C4.5456,6.8987 4.3746,7.0007 4.1896,7.0007 L0.7976,6.9997 C2.0056,9.1377 4.2786,10.6757 5.3776,11.3277 C5.7636,11.5577 6.2426,11.5577 6.6276,11.3277 C7.8926,10.5767 10.7086,8.6547 11.6686,5.9927 L8.5576,5.9717 Z"
      })));
      /* eslint-enable max-len */
    }
  }]);

  return HealthIcon;
}(_react.default.PureComponent);

exports.default = HealthIcon;
HealthIcon.defaultProps = {
  color: 'inherit'
};
HealthIcon.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.string
};